import React, { useMemo } from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { COLORS } from 'apps/web_forms/utils/constants';
import { debounce } from 'lodash';
import SearchIcon from 'apps/web_forms/assets/search-solid.svg';

const SearchContainer = styled.div`
  position: ${(props) => (props.sticky ? 'sticky' : 'static')};
  top: 0;
  z-index: 2;
  background-color: #ececec;
  display: flex;
  justify-content: flex-end;
  width: ${(props) => props.width};

  div {
    width: 20em;
  }

  input::-webkit-input-placeholder {
    font-size: 0.8em;
    color: #ccc;
  }

  .search-box {
    margin-top: 1em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-right-style: none;
    border-bottom-left-radius: 0.4em;
    border-top-left-radius: 0.4em;
    padding: 0.5em;
    cursor: auto;
    width: 87%;
  }

  .search-button {
    padding: 10px;
    background: ${COLORS.green};
    width: 2.5em;
    border: none;
    border-top-right-radius: 0.4em;
    border-bottom-right-radius: 0.4em;
    cursor: none;
    svg {
      width: 0.75em;
      height: 0.75em;
      color: white;
      margin-top: 0.2em;
    }
  }
`;

const SearchBox = ({ callback, sticky, width, id }) => {
  const returnValue = useMemo(
    () => debounce((value) => callback(value), 300),
    [callback]
  );

  // force change
  const onChange = ({ target }) => returnValue(target.value);

  return (
    <SearchContainer sticky={sticky} width={width}>
      <div>
        <input
          id={id}
          type='text'
          placeholder='Search...'
          className='search-box'
          name='search-box'
          onChange={onChange}
          data-testid='search-box'
        />

        <button type='submit' className='search-button'>
          <SearchIcon />
        </button>
      </div>
    </SearchContainer>
  );
};

SearchBox.propTypes = {
  callback: PropTypes.func.isRequired,
  sticky: PropTypes.bool,
  width: PropTypes.string,
  id: PropTypes.string,
};

SearchBox.defaultProps = {
  sticky: false,
  width: '100%',
  id: 'SearchBox',
};

export default SearchBox;
